<div class="device-details flex">
  <img
    class="device-details__image"
    src="assets/images/devices/{{ deviceCategory }}.png"
    [alt]="deviceCategory"
  />

  <button
    *ngIf="deviceId && deviceName !== 'Sky Glass'; else desc"
    class="btn--link link mt-8 d-block"
    (click)="handleRemoveDevice()"
  >
    <img src="./assets/images/check-circle.svg" alt="check" />
    <span class="label mt-6 d-block"> Remove </span>
  </button>

  <ng-template #desc>
    <div class="device-details__title typog-h4 mt-6">
      Tell us about your {{ deviceCategory | lowercase }}
    </div>
    <div class="mt-6">
      Please make sure to enter your details correctly, as they’re important for
      any future claims.
    </div>
  </ng-template>
</div>
